// Product carousel — Swiper (a11y + keyboard, responsive slidesPerView).
import Swiper from 'swiper';
import { Navigation, Keyboard, A11y } from 'swiper/modules';
import 'swiper/css';

export function initCarousels() {
  document.querySelectorAll('.product-carousel').forEach((root) => {
    const el = root.querySelector('.swiper');
    if (!el) return;

    new Swiper(el, {
      modules: [Navigation, Keyboard, A11y],
      slidesPerView: 1.2,
      spaceBetween: 16,
      loop: true,
      keyboard: { enabled: true },
      a11y: { enabled: true },
      navigation: {
        prevEl: root.querySelector('.carousel-arrow--prev'),
        nextEl: root.querySelector('.carousel-arrow--next'),
      },
      // Round 2: ~4.5 desktop tiles (PDF/responsive notes) for larger squares
      // and more comfortable hover copy.
      breakpoints: {
        768: { slidesPerView: 2.5, spaceBetween: 18 },
        1024: { slidesPerView: 3.5, spaceBetween: 20 },
        1200: { slidesPerView: 4.5, spaceBetween: 22 },
      },
    });
  });
}
